module.exports = __webpack_public_path__ + "static/media/UnderlineBlue.b65eff86.svg";